module.exports = "/fast-coin/img/coin/anim/out_1/out_1_009.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/out_1/out_1_009.png
// module id = 2305
// module chunks = 5